export const SERVER_PORT = process.env.SERVER_PORT || 3001;
export const API_URL = process.env.REACT_APP_API_URL || `http://localhost:${SERVER_PORT}`